import React from 'react';
import { useParams, NavLink, Navigate } from 'react-router-dom';
import { blogPosts } from '../data/blogPosts';
import { FiArrowLeft, FiCalendar, FiClock, FiUser } from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find(p => p.slug === slug);

  if (!post) {
    return <Navigate to="/blog" replace />;
  }

  return (
    <article className="bg-white min-h-screen pb-24">
      {/* Article Hero */}
      <div className="relative h-[50vh] min-h-[400px] w-full bg-ms-dark overflow-hidden">
        <div className="absolute inset-0 bg-ms-dark/60 z-10"></div>
        <img 
          src={post.image} 
          alt={post.title} 
          className="absolute inset-0 w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 z-20 flex flex-col justify-end pb-16">
          <div className="max-w-4xl mx-auto px-4 w-full">
            <NavLink to="/blog" className="inline-flex items-center text-white/80 hover:text-white font-bold uppercase tracking-widest text-xs mb-8 transition-colors">
              <SafeIcon icon={FiArrowLeft} className="mr-2" /> Zurück zur Übersicht
            </NavLink>
            <h1 className="text-4xl md:text-5xl lg:text-6xl font-black text-white uppercase tracking-tighter leading-tight mb-6">
              {post.title}
            </h1>
            <div className="flex flex-wrap items-center gap-6 text-sm font-bold text-white/80 uppercase tracking-widest">
              <span className="flex items-center gap-2"><SafeIcon icon={FiCalendar} /> {post.date}</span>
              <span className="flex items-center gap-2"><SafeIcon icon={FiClock} /> {post.readTime}</span>
              <span className="flex items-center gap-2"><SafeIcon icon={FiUser} /> {post.author}</span>
            </div>
          </div>
        </div>
      </div>

      {/* Article Content */}
      <div className="max-w-3xl mx-auto px-4 pt-16">
        <div className="
          text-lg text-ms-dark/80 font-medium leading-relaxed
          [&_h2]:text-3xl [&_h2]:font-black [&_h2]:text-ms-dark [&_h2]:mt-16 [&_h2]:mb-6 [&_h2]:uppercase [&_h2]:tracking-tighter [&_h2]:border-b [&_h2]:border-ms-light [&_h2]:pb-4
          [&_h3]:text-2xl [&_h3]:font-black [&_h3]:text-ms-dark [&_h3]:mt-10 [&_h3]:mb-4 [&_h3]:tracking-tight
          [&_ul]:list-none [&_ul]:pl-0 [&_ul]:mb-8 [&_ul_li]:mb-3 [&_ul_li]:relative [&_ul_li]:pl-8
          [&_ul_li::before]:content-[''] [&_ul_li::before]:absolute [&_ul_li::before]:left-0 [&_ul_li::before]:top-[0.6em] [&_ul_li::before]:w-2.5 [&_ul_li::before]:h-2.5 [&_ul_li::before]:bg-ms-blue [&_ul_li::before]:rounded-full
          [&_p]:mb-6 
          [&_a]:text-ms-solar [&_a]:font-bold [&_a]:underline [&_a]:underline-offset-4 hover:[&_a]:text-ms-blue [&_a]:transition-colors
        ">
          {post.content}
        </div>

        {/* Article Footer CTA */}
        <div className="mt-20 p-10 bg-brand-gradient rounded-[3rem] text-white text-center shadow-2xl">
          <h3 className="text-3xl font-black uppercase tracking-tighter mb-4">Sie planen ein Projekt?</h3>
          <p className="text-white/80 font-medium mb-8">Nutzen Sie unseren digitalen Planer oder kontaktieren Sie uns direkt für eine kostenlose Beratung vor Ort.</p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <NavLink to="/konfigurator" className="bg-white text-ms-solar px-8 py-4 rounded-2xl font-black uppercase tracking-widest hover:bg-ms-light transition-colors">
              Zum Konfigurator
            </NavLink>
            <NavLink to="/kontakt" className="bg-ms-dark text-white px-8 py-4 rounded-2xl font-black uppercase tracking-widest hover:bg-black transition-colors">
              Kontakt aufnehmen
            </NavLink>
          </div>
        </div>
      </div>
    </article>
  );
};

export default BlogPost;